import { useState, useEffect } from 'react';

const getPageSize = () => {
  if (window.innerWidth > 1440) {
    return 36;
  }
  return 40;
};

const usePageSize = () => {
  const [pageSize, setPageSize] = useState(getPageSize());

  useEffect(() => {
    setPageSize(getPageSize());
    // const handleResize = () => {
    //   setPageSize(getPageSize());
    // };

    // window.addEventListener('resize', handleResize);
    // return () => window.removeEventListener('resize', handleResize);
  }, []);

  return pageSize;
};

export default usePageSize; 